import { getSubdomain } from './utils/getSubdomain';
import LandingPage from './components/LandingPage';
import NotFound from './components/NotFound';

function App() {
  const subdomain = getSubdomain();

  // Development: Show helpful message if no subdomain
  if (!subdomain && import.meta.env.DEV) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-10 h-10 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">M-Taka Landing Pages</h1>
            <p className="text-gray-600 mb-6">
              This is the landing pages application. To test a landing page, add a subdomain parameter:
            </p>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
            <h3 className="font-semibold text-gray-900 mb-3">Development Testing:</h3>
            <div className="space-y-2 text-left">
              <div className="bg-white p-3 rounded border border-gray-200">
                <code className="text-sm text-blue-600">
                  http://localhost:5173?subdomain=kisumu
                </code>
                <p className="text-xs text-gray-500 mt-1">Load Kisumu landing page</p>
              </div>
              <div className="bg-white p-3 rounded border border-gray-200">
                <code className="text-sm text-blue-600">
                  http://localhost:5173?subdomain=nairobi
                </code>
                <p className="text-xs text-gray-500 mt-1">Load Nairobi landing page</p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-900">
              <strong>Production:</strong> In production, subdomains are detected automatically from the URL
              (e.g., <code>kisumu.m-taka.co.ke</code>)
            </p>
          </div>
        </div>
      </div>
    );
  }

  // No subdomain in production
  if (!subdomain) {
    return <NotFound message="No subdomain specified" />;
  }

  // Render landing page for the subdomain
  return <LandingPage subdomain={subdomain} />;
}

export default App;
